import classNames from 'classnames';
import React from 'react';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import useBreakpoint, { Breakpoint } from '../../hooks/useBreakpoint';
import CollapsibleText from '../CollapsibleText/CollapsibleText';

import styles from './Hero.module.scss';

type Props = {
  title: string;
  description: string;
  image?: string;
};

const Hero = ({ title, description, image }: Props) => {
  const breakpoint: Breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.xs;
  const { config } = useConfigStore.getState();
  const articleBackground = config?.custom?.articleBackgroundImageAlignment;

  const alt = ''; // intentionally empty for a11y, because adjacent text alternative
  const posterClass = classNames(styles.poster, {
    [styles['align-left']]: articleBackground === 'left',
    [styles['align-right']]: articleBackground === 'right',
    [styles['align-top']]: articleBackground === 'top',
    [styles['align-bottom']]: articleBackground === 'bottom',
    [styles['align-center']]: articleBackground === 'center',
  });
  return (
    <div className={classNames(styles.hero, styles.heroPadding)}>
      <img className={posterClass} src={image} alt={alt} />
      <div className={styles.posterFade} />
      <div className={styles.info}>
        <h1 className={styles.title}>{title}</h1>
        <CollapsibleText text={description} className={styles.description} maxHeight={isMobile ? 60 : 'none'} />
      </div>
    </div>
  );
};

export default Hero;
